import { createContext, useContext } from "react";

import { AddSnackbarMessageAction, SnackbarMessage } from "./types";

export type SnackbarMessageActions = {
  addMessage: AddSnackbarMessageAction;
  removeMessage: (message: SnackbarMessage) => void;
};

export const SnackbarMessageActionsContext =
  createContext<null | SnackbarMessageActions>(null);

export const useSnackbarMessageActionsContext = () =>
  useContext(SnackbarMessageActionsContext);
